/**
 * Version utility - Single source of truth for application version.
 * Reads from package.json via process.env.npm_package_version (injected by Create React App at build time).
 */

const FALLBACK_VERSION = "0.1.0";

/**
 * Get the current application version.
 * In development, returns the version from package.json.
 * In production build, CRA replaces process.env.npm_package_version with the actual version.
 * @returns {string} The application version string (e.g., "0.1.0")
 */
export function getVersion() {
  if (typeof process !== "undefined" && process.env && process.env.npm_package_version) {
    return process.env.npm_package_version;
  }
  return FALLBACK_VERSION;
}

/**
 * Get the formatted version string for display.
 * @returns {string} Formatted version string (e.g., "Orrith v0.1.0")
 */
export function getFormattedVersion() {
  return `Orrith v${getVersion()}`;
}

/**
 * Get the short version string (just the version number).
 * @returns {string} Version number only (e.g., "0.1.0")
 */
export function getShortVersion() {
  return getVersion();
}

export default {
  getVersion,
  getFormattedVersion,
  getShortVersion,
};